var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99986 0.832031C6.70491 0.832031 5.69109 1.38542 4.79618 1.8739L4.76234 1.89236C3.83404 2.39895 3.02636 2.83043 2.00922 2.83043H1.61306L1.52247 3.21578C0.693703 6.74103 1.35745 9.94819 3.10236 12.1796L12.6961 2.59347C12.2121 2.41981 11.7451 2.16723 11.242 1.89246L11.2117 1.87591C10.3161 1.38664 9.30095 0.832031 7.99986 0.832031Z",
    fill: "#2A7341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8751 2.82857L3.76623 12.9293C4.85646 14.0176 6.25507 14.7913 7.89492 15.1429L7.99983 15.1654L8.10474 15.1429C13.1001 14.0718 15.857 9.08459 14.4772 3.21578L14.3867 2.83043H13.9905C13.9517 2.83043 13.9132 2.8298 13.8751 2.82857Z",
    fill: "#2A7341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVerified);
export default __webpack_public_path__ + "static/media/ic_verified.a4bdcedd1632b7798b21ed31d80a774a.svg";
export { ForwardRef as ReactComponent };